import React from 'react';
import { motion } from 'framer-motion';
import { IDS } from '@/constants/testIds';

const ALI_IMG = 'https://customer-assets-lxgj4vgw.emergentagent.net/job_holi-diwali-india/artifacts/sdztug2m_IMG_20241113_100008506.webp';

const STATS = [
  { n: '12+', label: 'Лет в Индии' },
  { n: '3 500+', label: 'Русскоязычных гостей' },
  { n: '9.7 / 10', label: 'Оценка на Tripster' },
  { n: '5', label: 'Языков' },
];

export default function AboutAli() {
  return (
    <section id="about-ali" data-testid={IDS.sectionAli} className="py-24 md:py-40 border-t border-border/60">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="lg:col-span-5"
          >
            <div className="relative aspect-[3/4] overflow-hidden">
              <img src={ALI_IMG} alt="Гид Али" className="w-full h-full object-cover" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/10 to-black/70" />
              <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between">
                <div>
                  <p className="overline text-white/80">Ваш гид</p>
                  <p className="font-serif-display text-4xl md:text-5xl text-white">Али</p>
                </div>
                <a
                  href="https://experience.tripster.ru/guide/132942/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[10px] uppercase tracking-widest2 font-bold border border-white/70 text-white px-3 py-2 hover:bg-white hover:text-foreground transition-colors"
                >
                  Tripster ↗
                </a>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.1 }}
            className="lg:col-span-7"
          >
            <p className="overline mb-6">№ 05 · About the guide</p>
            <h2 className="font-serif-display text-5xl md:text-6xl lg:text-7xl leading-[0.9] mb-8">
              Али — <em className="text-saffron">не гид,</em> а проводник.
            </h2>
            <div className="space-y-5 text-foreground/80 text-base md:text-lg font-light leading-relaxed max-w-2xl">
              <p>
                Более 12 лет в Индии. Провёл через страну более 3 500 русскоязычных путешественников. Живёт между Дели и Джайпуром, знает всех — от министерских семей до владельцев чайных на грани трассы.
              </p>
              <p>
                На туре с Али вы не «смотрите Индию» — вы <em className="text-saffron">живёте</em> внутри неё. Ужин в семье, разговор с монахом на гхатах Варанаси, знакомство с ремесленником Джайпура, чей род делает эти узоры с 17 века.
              </p>
              <p className="italic font-serif-display text-2xl text-foreground/90">
                «Моя работа — не показать Индию. Моя работа — сделать так, чтобы Индия показала вам себя.»
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-14 pt-10 border-t border-border/60">
              {STATS.map((s) => (
                <div key={s.label}>
                  <div className="font-serif-display text-4xl md:text-5xl text-saffron leading-none">{s.n}</div>
                  <div className="text-[10px] uppercase tracking-widest2 text-foreground/60 mt-2">{s.label}</div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
